import { v1Migration } from './v1';

const migrations = [v1Migration];

export const migrationManager = {
  async runMigrations(db) {
    for (const migration of migrations) {
      if (db.verno < migration.version) {
        await db.transaction('rw', db.tables, () => {
          return migration.migrate(db);
        });
      }
    }
  }
};
